import { postDataApi } from "./actions";
import { URL_CONSTANTS } from "./urls";

//addAdData instead of addCustomerData
export  const createOrder = (params) => {
  return postDataApi(URL_CONSTANTS.create_order, params);
};


